import React from 'react';

import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Route, withRouter } from 'react-router-dom';
import SplitContainer from '@zippytech/react-toolkit/SplitContainer'
import '@zippytech/react-toolkit/SplitContainer/index.css'
import ReactResizeDetector from 'react-resize-detector';

import DesignerIndex from './DesignerPane'
import MyActivities from "./BrowserPane/MyActivities";
import { HelpComponent } from "../../common/HelpComponent";
import ResourcePaneIndex from "./../Initiatives/ResourcesPane";
import './activity.css';

class Activities extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      splitAt: "-40%",
      browserPaneSplit: "25%",
      collapsedResourcePaneIndex: null
    }
  }

  componentWillMount() {
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    dispatch.initiatives.showResourecePane(null);
    dispatch.app.setCurrentContext("activities");
    const currentPosition = {
      containerId: null,
      rowNo: 0,
    }
    dispatch.initiatives.setPosition(currentPosition);
    this.clearFilter();
    this.setState({ collapsedResourcePaneIndex: null })
  }

  componentWillUnmount() {
    //dispatch.initiatives.setSelectedActivityData({});
    this.endFun()
  }
  async endFun() {
    await dispatch.organizationUnit.showResourecePane(null)
    await dispatch.initiatives.showResourecePane(null);
    await dispatch.initiatives.setSelectedActivityData({});
  }

  clearFilter() {
    this.props.advancedFilterProperties.roles = [];
    this.props.advancedFilterProperties.stateActiveChecked = false;
    this.props.advancedFilterProperties.stateOnHoldChecked = false;
    this.props.advancedFilterProperties.statusNotStartedChecked = false;
    this.props.advancedFilterProperties.statusCompletedChecked = false;
    this.props.advancedFilterProperties.statusIssueChecked = false;
    this.props.advancedFilterProperties.statusInProgressChecked = false;
    this.props.advancedFilterProperties.statusDelayedChecked = false;
    this.props.advancedFilterProperties.showAllRoles = false;
    this.props.advancedFilterProperties.serarchedRolesAvailable = false;
    this.props.advancedFilterProperties.searchedRoles = [];
    this.props.advancedFilterProperties.value = '';
    this.props.advancedFilterProperties.userSearchValue = '';
    this.props.advancedFilterProperties.selectedUsers = [];
    this.props.advancedFilterProperties.serarchedUsersAvailable = false;
    dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.props.advancedFilterProperties));

    this.props.raciFilterProperties.raciAllChecked = true;
    this.props.raciFilterProperties.accountable = false;
    this.props.raciFilterProperties.responsible = false;
    this.props.raciFilterProperties.consulted = false;
    this.props.raciFilterProperties.informed = false;
    dispatch.initiatives.setRACIFilterProperties(Object.assign({}, this.props.raciFilterProperties));
  }

  onResizeResourcepane = (width, height) => {
    let windowHeight = window.innerHeight
    let designerDimension = {
      width: width,
      windowHeight: windowHeight,
      height: height
    }
    dispatch.initiatives.setDesignerDimension(designerDimension);


    const setUniqueId = this.props.setUniqueId;
    if (setUniqueId) {
      const setPositionElement = document.getElementById(setUniqueId);
      if (setPositionElement) {
        setTimeout(() => {
          setPositionElement.scrollIntoView({ block: "center", inline: "nearest" });
        }, 100);
      }
    }
  }

  keyPress = async (e) => {

    if (e.keyCode === 27) {
      //this.setState({ collapsedResourcePaneIndex: null })
      dispatch.app.setCollapsedResourcePaneIndexTemp(null)
      await dispatch.initiatives.showResourecePane(null);

      //dispatch.app.setCollapsedResourcePaneIndex(null)

      dispatch.initiatives.setIdToCenterPosition(null);
      dispatch.initiatives.setSelectedActivityData({});
    }
  }


  render() {

    const { resourcePaneFlag, splitAtSize } = this.props
    return (
      <SplitContainer
        orientation="vertical"
        minSize="10%"
        maxSize={['50%', null]}
        fillSides={[true, true]}
        collapsible={[true, false]}
        defaultSplitAt="25%"
        resizeProxy={true}
        onKeyDown={this.keyPress}
        collapsedIndex={this.state.collapsedBrowserPaneIndex}
        splitAt={this.state.browserPaneSplit}
        onResize={(browserPaneSplit) => {
          if (Number(browserPaneSplit.replace("%", "")) < 11) {
            this.setState({ collapsedBrowserPaneIndex: 0 })
          } else {
            this.setState({ browserPaneSplit })
          }
        }}
        onExpand={() => {
          this.setState({
            collapsedBrowserPaneIndex: null,
            browserPaneSplit: "25%"
          })
        }}
        onCollapse={(index) => {
          this.setState({
            collapsedBrowserPaneIndex: index,
            browserPaneSplit: "25%"
          })
        }}

      >
        <SplitContainer
          orientation="horizontal"
          minSize="10%"
          collapsible={[false, true]}
          defaultSplitAt="75%">
          <SplitContainer.Side className="Split-BrowserPane">
            <MyActivities  {...this.props} />
          </SplitContainer.Side>
          <SplitContainer.Side className="Split-HelpPane">
            <HelpComponent />
          </SplitContainer.Side>
        </SplitContainer>
        <SplitContainer
          orientation="horizontal"
          splitAt={resourcePaneFlag && splitAtSize ? splitAtSize : "100%"}
          fillSides={[true, true]}
          minSize={["0%", "0%"]}
          maxSize={[null, '81%']}
          collapsible={[true, true]}
          locked={resourcePaneFlag === null}
          resizeProxy={true}
          collapsedIndex={this.props.collapsedResourcePaneIndexTemp === 1 || this.props.collapsedResourcePaneIndexTemp === 0 ? this.state.collapsedResourcePaneIndex : this.props.collapsedResourcePaneIndexTemp}
          onResize={(splitAt) => {
            if (Number(splitAt.replace("%", "")) < 30) {
              this.setState({ collapsedResourcePaneIndex: 0 })
              dispatch.app.setCollapsedResourcePaneIndexTemp(0)
            } else if (Number(splitAt.replace("%", "")) > 80) {
              this.setState({ collapsedResourcePaneIndex: 1 })
              dispatch.app.setCollapsedResourcePaneIndexTemp(1)
            } else {
              this.setState({ collapsedResourcePaneIndex: null })
              dispatch.initiatives.splitAt(splitAt)
              dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            }
          }}
          onExpand={() => {
            this.setState({ collapsedResourcePaneIndex: null })
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            dispatch.initiatives.splitAt("60%")
          }}
          onCollapse={(index) => {
            this.setState({ collapsedResourcePaneIndex: index })
            dispatch.app.setCollapsedResourcePaneIndexTemp(index)
          }}

        >
          <SplitContainer.Side className="Split-DesignerPane">
            <Route exact path="/app/:accountId/_ws/:workspaceId/_at/:myactivities" render={() => (<DesignerIndex {...this.props} />)} />
            <Route exact path="/app/:accountId/_ws/:workspaceId/_at/:myactivities/:initiativeStatus" render={() => (<DesignerIndex {...this.props} />)} />
            <Route exact path="/app/:accountId/_ws/:workspaceId/_at/:myactivities/:initiativeStatus/:initiativeId" render={() => (<DesignerIndex {...this.props} />)} />
          </SplitContainer.Side>

          <SplitContainer.Side className="Split-ResourcePane" >
            <ReactResizeDetector handleWidth handleHeight onResize={this.onResizeResourcepane}>
              {this.props.activeTab === "myactivities" ? <ResourcePaneIndex {...this.props} /> : ""}
            </ReactResizeDetector>
          </SplitContainer.Side>
        </SplitContainer>
      </SplitContainer >
    );
  }
}

function mapStateToProps(state) {
  return {
    resourcePaneFlag: state.initiatives.resourcePaneFlag,
    initiativeId: state.initiatives.initiativeId,
    publishedContent: state.createPack.publishedContent,
    selectedActivityData: state.initiatives.selectedActivityData,
    splitAtSize: state.initiatives.splitAtSize,
    user: state.app.user,
    componentDesignerDimension: state.initiatives.componentDesignerDimension,
    associatedTeams: state.initiatives.associatedTeams,
    initiativeMemberActivities: state.initiatives.initiativeMemberActivities,
    loaderInMemAac: state.loading.effects.initiatives.getInitiativeActivitiesForMember,
    raciFilterProperties: state.initiatives.raciFilterProperties,
    advancedFilterProperties: state.initiatives.advancedFilterProperties,
    activityRACIUsers: state.initiatives.activityRACIUsers,
    selectedinitiativeGraph: state.initiatives.selectedinitiativeGraph,
    activeTab: state.initiatives.activeTab,
    loadingMyActivities: state.loading.effects.initiatives.getInitiativeActivitiesForMember,
    selectedOrganisation: state.app.selectedOrganisation,
    position: state.initiatives.position,
    initiativeCountDataForMember: state.initiatives.initiativeCountDataForMember,
    raciCount: state.initiatives.raciCount,
    activeStatus: state.initiatives.activeStatus,
    currentNote: state.initiatives.currentNote,
    collapsedResourcePaneIndexTemp: state.app.collapsedResourcePaneIndexTemp,
    setUniqueId: state.initiatives.setUniqueId,
    selectedDataById: state.initiatives.selectedDataById,
    loadingSingleActivityData: state.loading.effects.initiatives.getSelectedActivityDetails && state.loading.models.initiatives,
    accessToken: state.login.accessToken,
    envData: state.app.envData,
    selectedAccount: state.app.selectedAccount,
    loadingUpdateInitiativeActivities: state.loading.effects.initiatives.updateInitiativeActivities && state.loading.models.initiatives,
    loadingUpdateMemberActivities: state.loading.effects.initiatives.updateMemberActivities && state.loading.models.initiatives,
    initiativeOwnerDetails: state.initiatives.initiativeOwnerDetails ,//This props is added for KLM-8959
    selectedContent:state.content.selectedContent
  };
}

const connectedActivitiesDesignerPage = withRouter(connect(mapStateToProps)(Activities))

export { connectedActivitiesDesignerPage as Activities }; 
